import api from 'services/api.service';

const resource = '/templates';

export const sendTemplatedEmail = ({ taskId }) => api
  .post(`${resource}/send-templated-email`, { taskId });

export const deleteTemplates = ({ ids }) => api
  .post(`${resource}/delete-templates`, { ids });
